import React from 'react';
import { CardElement } from '@stripe/react-stripe-js';
import Button from '../../ui/Button';
import LoadingSpinner from '../../ui/LoadingSpinner';
import SavedPaymentMethodsDropdown from './SavedPaymentMethodsDropdown';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import { formatCurrency } from '../../../utils/formatters';

const ReturnLabelGeneration = ({
  selectedRate,
  isLoadingRates,
  requiresPayment,
  paymentAmount,
  savedPaymentMethods = [],
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  isProcessing,
  handleGenerateLabel
}) => {
  if (!selectedRate || isLoadingRates) {
    return null;
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-medium mb-4">Generate Return Label</h3>
      
      {requiresPayment ? (
        <div>
          <div className="flex items-center mb-4">
            <CurrencyDollarIcon className="h-5 w-5 text-gray-500 mr-2" />
            <p className="text-gray-700">
              You need to pay {formatCurrency(paymentAmount, selectedRate.currency)} to generate a return label.
            </p>
          </div>
          
          {savedPaymentMethods.length > 0 && (
            <div className="mb-4">
              <SavedPaymentMethodsDropdown 
                savedPaymentMethods={savedPaymentMethods}
                selectedPaymentMethod={selectedPaymentMethod}
                onChange={(e) => setSelectedPaymentMethod(e.target.value)}
              />
            </div>
          )}
          
          {!selectedPaymentMethod && (
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Credit Card
              </label>
              <div className="border border-gray-300 rounded-md p-3">
                <CardElement 
                  options={{
                    style: {
                      base: {
                        fontSize: '16px',
                        color: '#424770',
                        '::placeholder': {
                          color: '#aab7c4',
                        },
                      },
                      invalid: {
                        color: '#9e2146',
                      },
                    },
                  }}
                />
              </div>
            </div>
          )}
          
          <Button
            variant="primary"
            onClick={handleGenerateLabel}
            disabled={isProcessing}
            className="w-full"
          >
            {isProcessing ? <LoadingSpinner size="sm" /> : 'Pay & Generate Label'}
          </Button>
        </div>
      ) : (
        <div>
          <p className="text-gray-700 mb-4">
            Generate a return shipping label to send the items back to the merchant.
          </p>
          
          <Button
            variant="primary"
            onClick={handleGenerateLabel}
            disabled={isProcessing}
            className="w-full"
          >
            {isProcessing ? <LoadingSpinner size="sm" /> : 'Generate Label'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReturnLabelGeneration; 